import { render, staticRenderFns } from "./PayersBalanceDetails.vue?vue&type=template&id=3086e79e&scoped=true"
import script from "./PayersBalanceDetails.vue?vue&type=script&lang=js"
export * from "./PayersBalanceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3086e79e",
  null
  
)

export default component.exports